function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(90 39.15 39.15)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  opacity: 0.4,
  cx: 38.88,
  cy: 38.88,
  r: 38.88
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 38.88,
  cy: 38.88,
  r: 28.08
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  fillRule: "nonzero",
  d: "M42.914 30.8l-.94-.939-9.86 9.86 9.86 9.862.94-.94-8.922-8.921z"
}));

var SvgFlechaup = function SvgFlechaup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 79"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgdmlld0JveD0iMCAwIDc5IDc5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNjIgKDkxMzkwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4NCiAgICA8dGl0bGU+ZmxlY2hhPC90aXRsZT4NCiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4NCiAgICA8ZyBpZD0iUHJlc2VudGFjaW9uIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9ImludGVyZmF6MDVfZW5lcmdpYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExNjEuMDAwMDAwLCAtMzgxLjAwMDAwMCkiPg0KICAgICAgICAgICAgPGcgaWQ9Im1hcmNhZG9yZXMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNjEuMDAwMDAwLCAzODEuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPGcgaWQ9ImZsZWNoYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzkuMzAwMDAwLCAzOS4wMDAwMDApIHJvdGF0ZSgtMjcwLjAwMDAwMCkgdHJhbnNsYXRlKC0zOS4zMDAwMDAsIC0zOS4wMDAwMDApIHRyYW5zbGF0ZSgwLjMwMDAwMCwgMC4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iI0ZGRkZGRiIgb3BhY2l0eT0iMC40IiBjeD0iMzguODgiIGN5PSIzOC44OCIgcj0iMzguODgiPjwvY2lyY2xlPg0KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjRkZGRkZGIiBjeD0iMzguODgiIGN5PSIzOC44OCIgcj0iMjguMDgiPjwvY2lyY2xlPg0KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbD0iI0ZGMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MS45NzQ4NDksIDM5LjcyMTkwNikgcm90YXRlKC0zMTUuMDAwMDAwKSB0cmFuc2xhdGUoLTQxLjk3NDg0OSwgLTM5LjcyMTkwNikgIiBwb2ludHM9IjM2LjMzMDI5MiAzMi43NDkyMTgyIDM1LjAwMjE2MTEgMzIuNzQ5MjE4MiAzNS4wMDIxNjExIDQ2LjY5NDU5MzcgNDguOTQ3NTM2NSA0Ni42OTQ1OTM3IDQ4Ljk0NzUzNjUgNDUuMzY2NDYyNyAzNi4zMzAyOTIgNDUuMzY2NDYyNyI+PC9wb2x5Z29uPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==";
export { SvgFlechaup as ReactComponent };